import {createFileRoute, Outlet, redirect} from "@tanstack/react-router";

function DriverShell() {
    //   useDriverSetlistsWatch();
    return <Outlet></Outlet>
}

export const Route = createFileRoute("/_auth/driver")({
    component: DriverShell,
    beforeLoad: ({context}) => {
        if (!!context.myself && !context.myself.canDrive) {
            throw redirect({to: "/", replace: true});
        }
        return context;
    }
});
